import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { getProjects, getProjectForms } from '../../services/projectService';
import { getFormWidgets } from '../../services/formService';
import { WidgetTypes } from '../../constants/QuestionTypes';
import _ from 'lodash';
import { stripTags } from '../common/commonFuncs';
import CustomLoader from '../common/Loader';
import * as Icon from 'react-feather';
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';
import { logActivity } from '../../services/utilService';
import ReportSettings from './ReportSettings';
import { addReport } from '../../services/reportService';
import { ExitStatus } from 'typescript';

class AddReport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            preloadData: this.props.preloadData ? this.props.preloadData : undefined,
            loading: true,
            projects: [],
            projectSelected: {},
            projectForms: [],
            formSelected: {},
            formsWidgetsList: [],
            reportList: [],
            selectedFormWidgetsList: [],
            reportSelected: {}
        };
    }

    componentDidMount() {
        this.inputChangeEvent = this.inputChangeEvent.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.loadProjects().
            // then(this.loadReports).
            then(this.fillPreloadData).
            then(this.setState({ loading: false }));
    }

    loadProjects = async () => {
        const { data: projects } = await getProjects();
        this.setState({ projects });
        //console.log('Add New p', projects, this.state.preloadData)
    };

    fillPreloadData = async () => {
        let reportSelected = {};
        if (this.state.preloadData) {
            let preloadDataObj = this.state.preloadData;
            reportSelected = {
                'reportID': preloadDataObj[0],
                'reportName': preloadDataObj[1],
                'reportDesc': preloadDataObj[2],
                'projectID': preloadDataObj[3],
                'projectName': preloadDataObj[4]
            };
        }
        else {
            reportSelected = {
                'projectID': this.state.projects[0]['Project_ID'],
                'projectName': this.state.projects[0]['Project_Name']
            };
        }
        this.setState({ reportSelected });
        Promise.resolve('success');
    }

    inputChangeEvent(e) {
        let reportSelected = this.state.reportSelected, inputData = e.target;
        reportSelected[inputData.name] = inputData.value;
        this.setState({ reportSelected });
    }

    clearFields() {
        let reportSelected = this.state.reportSelected;
        reportSelected['reportName'] = '';
        reportSelected['reportDesc'] = '';
        reportSelected['projectID'] = this.state.projects ? this.state.projects[0]['Project_ID'] : 0;
        this.setState({ reportSelected });
    }

    async handleSave() {
        let reportSelected = this.state.reportSelected, isvalid = Object.keys(reportSelected).length > 0;
        if (Object.keys(reportSelected).length > 0) {
            /* Form Validation */
            for (const key in reportSelected) {
                if (reportSelected[key] !== '' && reportSelected[key] !== undefined) { continue; }
                else {
                    if (key !== 'reportDesc') {
                        isvalid = false;
                        break;
                    }
                }
            }
            if (isvalid) {
                try {
                    //API to save Report
                    console.log(reportSelected);
                    let data = await addReport(this.state.reportSelected);
                    if (typeof data === 'string') {
                        throw new Error('error');
                    }
                    else {
                        toaster('success', 'Report Saved successfully.')
                    }
                }
                catch (e) {
                    toaster('error', 'Oops! Cannot Save form at this time. Please try again later.')
                }
            }
            else {
                toaster('warning', 'Please fill required Details for saving!')
            }
        }
        else {
            toaster('warning', 'Please fill required Details for saving!')
        }
    }

    render() {
        const { preloadData, projects, reportSelected } = this.state;

        const loading = (<CustomLoader loading={this.state.loading} />);
        try {
            if (this.state.loading) { return loading }
            else {
                return (
                    <React.Fragment>
                        <div className='card card-header-actions'>
                            <div className='card-body'>
                                <div className='align-items-center justify-content-between'>
                                    <h4 className='ml-3'>{(preloadData ? 'Edit' : 'Add New') + ' Report'}</h4>
                                    <div className='row ml-2 mt-4'>
                                        <span className='col col-md-2'>Report Name</span>
                                        <input type='search' id='' name='reportName' className='col col-md-3 form-inline form-control' value={reportSelected.reportName} onChange={this.inputChangeEvent} />
                                    </div><br />
                                    <div className='row ml-2'>
                                        <span className='col col-md-2 align-top'>Report Description</span>
                                        <textarea className='col col-md-3 form-inline form-control' id='' name='reportDesc' rows={2} value={reportSelected.reportDesc} onChange={this.inputChangeEvent} />
                                    </div><br />
                                    <div className='row ml-2'>
                                        <span className='col col-md-2'>Select Project</span>
                                        <select name='projectID' className='btn btn-lg dropdown-toggle border col col-md-3' value={reportSelected.projectID} onChange={this.inputChangeEvent}>
                                            {
                                                projects.map((p) => {
                                                    return (<option value={p.Project_ID}>{p.Project_Name}</option>);
                                                })
                                            }
                                        </select>
                                    </div><br /><br />
                                    <div className='row ml-2'>
                                        <button className='btn btn-primary ml-2' onClick={this.handleSave}>{preloadData ? 'Save' : 'Add'}</button>
                                        <button className='btn btn-success ml-2' onClick={this.clearFields}>Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ToastContainer />
                    </React.Fragment >
                );
            }
        }
        catch (e) {
            console.error('Error loading Add Report: ', e);
            return (loading);
        }
    }
}

export default withRouter(AddReport);